import baseAxios from "axios";

export const BASE_URL = "https://api.sewapress.com.np/api/v1/core/";

export const axios = baseAxios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});
